import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CommonLocalizationService } from './common-localization.service';


export class CustomLoader implements TranslateLoader {
    constructor(private commonLocalizationService: CommonLocalizationService) { }

    getTranslation(lang: string): Observable<any> {
        return this.commonLocalizationService.getLocalizationData(lang) as Observable<any>;
    }
}
